import type * as lazyIndex from './lazyIndex';
import { LazyModule, registerLazyOrchestrator, LazyAction } from 'owa-bundling';
import onAcquisitionsRemoteRefresh from 'owa-m365-acquisitions/lib/actions/onAcquisitionsRemoteRefresh';
import onUninstallM365Acquisition from 'owa-m365-acquisitions/lib/actions/onUninstallM365Acquisition';
import { optionalConnectedExperiencesStatusChanged } from 'owa-privacy-utils/lib/actions/optionalConnectedExperiencesStatusChanged';
import { onAppBarTrigger } from 'owa-nova-actions/lib/actions/onAppBarTrigger';
import onAccountSwitched from 'owa-mail-account-actions/lib/actions/onAccountSwitched';
import closeAddinPane from 'owa-addins-store/lib/actions/closeAddinPane';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "Addins" */ './lazyIndex'),
    {
        name: 'Addins',
    }
);

registerLazyOrchestrator(closeAddinPane, lazyModule, m => m.closeAddinPaneOrchestrator);
registerLazyOrchestrator(onAppBarTrigger, lazyModule, m => m.appBarChangeOrchestrator);
registerLazyOrchestrator(onAccountSwitched, lazyModule, m => m.onAccountSwitchedOrchestrator);
registerLazyOrchestrator(
    optionalConnectedExperiencesStatusChanged,
    lazyModule,
    m => m.refreshAddinsOnOCESettingChangeOrchestrator
);
registerLazyOrchestrator(
    onUninstallM365Acquisition,
    lazyModule,
    m => m.refreshAddinsOnUninstallM365AcquisitionOrchestrator
);
registerLazyOrchestrator(
    onAcquisitionsRemoteRefresh,
    lazyModule,
    m => m.refreshAddinsOnAcquisitionsRemoteRefreshOrchestrator
);

export const lazyInstallWebAddinsOnMonarchToggle: LazyAction<
    typeof lazyIndex.installWebAddinsOnMonarchToggle,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.installWebAddinsOnMonarchToggle);

export const lazyInitializeExtensibilityContext: LazyAction<
    typeof lazyIndex.initializeExtensibilityContext,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeExtensibilityContext);
export const lazyLaunchTranslateCommand: LazyAction<
    typeof lazyIndex.launchTranslateCommand,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.launchTranslateCommand);
export const lazyInitializeAddinsForItem: LazyAction<
    typeof lazyIndex.initializeAddinsForItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeAddinsForItem);
export const lazyDeinitializeAddinsForItem: LazyAction<
    typeof lazyIndex.deinitializeAddinsForItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.deinitializeAddinsForItem);
export const lazyRunContextualEvaluationAndUpdate: LazyAction<
    typeof lazyIndex.runContextualEvaluationAndUpdate,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.runContextualEvaluationAndUpdate);
